import React, { useState, useCallback } from 'react'
import AllProductService from './service'
import { useSearchContext } from './Hook/searchStates'
import { debounce } from '@cms/utils'

import SearchDesktop from './SearchDesktop'
import * as S from './styled'

export const translatedSeeMoreExamsText = "Ver mais exames"

const Search = () => {
  const searchContext = useSearchContext()
  const openDesktopState = searchContext.getSearchOpenState()

  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(false)
  const [searchResult, setSearchResult] = useState([])
  const [notSearchResult, setNotSearchResult] = useState(false)

  const onSearch = term => {
    if (term === '') return
    setLoading(true)
    setNotSearchResult(false)

    AllProductService.search(term).then(data => {
      if (term.length > 0 && data.length === 0) {
        setNotSearchResult(true)
        return setSearchResult(data)
      }
      if (data.length > 3) {
        const slice = data.slice(0, 3)
        slice.push(
          {
            nome: translatedSeeMoreExamsText,
            sinonimo: [],
            slug: '/exames'
          }
        )
        setLoading(false)
        return setSearchResult(slice)
      } else {
        data.push(
          {
            nome: 'Mais exames',
            sinonimo: [],
            slug: '/exames'
          }
        )
        setLoading(false)
        return setSearchResult(data)
      }
    })
  }

  const debouncedSearch = useCallback(debounce(onSearch, 500), [])

  const inputChange = e => {
    const term = e.target.value
    setQuery(term)
    debouncedSearch(term)
  }

  const handleSubmit = e => {
    e.preventDefault()
    document.querySelector('#search-query').blur()
    onSearch(query)
  }

  const openDesktop = () => {
    searchContext.setSearchOpenState(isChecked => !isChecked)
    clearSearch()
  }

  const clearSearch = () => {
    setQuery('')
    onSearch('')
  }

  return (
    <>
        {query && (
      <S.Overlay
        id="SearchOverlay-div"
        data-testid="SearchOverlay-div"
        showOverlay={query}
        onClick={openDesktop} />
    )}
    <SearchDesktop
      openDesktopState={openDesktopState}
      openDesktop={openDesktop}
      handleSubmit={handleSubmit}
      query={query}
      inputChange={inputChange}
      clearSearch={clearSearch}
      notSearchResult={notSearchResult}
      searchResult={searchResult}
      loading={loading}
    />
    </>
  )
}

export default Search
